module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }), _vm._v(" "), _c('main', {
    staticClass: "wrapper-404"
  }, [_c('div', {
    staticClass: "error-404"
  }, [_c('h1', [_vm._v("\n          服务器"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("BOOM!BOOM!BOOM")]), _vm._v("~程序员努力抢修中...\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "moon"
  }, [_c('span', [_vm._v("5")]), _c('span', [_c('img', {
    staticClass: "icon has-animation",
    attrs: {
      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
      "alt": ""
    }
  })]), _c('span', [_c('img', {
    staticClass: "icon has-animation",
    attrs: {
      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
      "alt": ""
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fca6bdc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/dashboard/500.vue
// module id = 446
// module chunks = 2